import { useEffect, useRef } from 'react';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { API_URL } from '@/lib/api';

/**
 * /accept-invite?token=… — порт frontend/src/app/accept-invite/page.tsx.
 *
 * Standalone-страница (БЕЗ AppShell). Просто показывает «Принимаем приглашение…»
 * и редиректит на backend GET /api/v1/accept-invite?token=… — там бэкенд установит
 * cookie и redirect-ит на /onboarding/profile или /dashboard.
 */
export function AcceptInvitePage() {
  const initiated = useRef(false);

  useEffect(() => {
    if (initiated.current) return;
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) return;
    initiated.current = true;
    window.location.replace(
      `${API_URL}/api/v1/accept-invite?token=${encodeURIComponent(token)}`,
    );
  }, []);

  return (
    <div className="min-h-dvh flex items-center justify-center bg-secondary/40 p-6">
      <Card className="w-full max-w-md text-center">
        <CardContent className="pt-8 pb-6 space-y-3">
          <div className="text-5xl">🎉</div>
          <h1 className="text-xl font-semibold">Принимаем приглашение…</h1>
          <p className="text-sm text-muted-foreground">
            Минуту, готовим ваш аккаунт
          </p>
          <div className="pt-3 flex justify-center">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default AcceptInvitePage;
